// extracted by mini-css-extract-plugin
export var avatarContainer = "_3l-1";
export var largeAvatarContainer = "_3l-2";
export var smallAvatarContainer = "_3l-0";